// This is the card that will display the jobsite information.
//  It will display the jobsite name, address, notes, and a few icons that will allow the user to interact with the jobsite.
import { useState } from "react";
import { FaCog, FaUserClock, FaStickyNote } from "react-icons/fa";
import NotesInCards from "./NotesInCards";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteJobsite, toggleJobsiteStatus  } from "../features/jobsites/jobsitesSlice";
import SelectForemanModal from "./SelectForemanModal";

const JobSiteCard = ({ jobSite }) => {
   
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showDropdown, setShowDropdown] = useState(false);
    const [editNotesClicked, setEditNotesClicked]= useState(false);

    // Modal state
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteConfirmInput, setDeleteConfirmInput] = useState("");
    const [showForemanModal, setShowForemanModal] = useState(false);

    //toggle the edit notes button
    const handleEditNotes = () => { 
        setEditNotesClicked(!editNotesClicked);
       
    }

    const handleCogClick = () => {
     
      setShowDropdown(!showDropdown); 

    }

  
    //Navigate to he jobsite/attendance page
    const handleViewAttendance = () => {
     
      navigate('/jobsite/attendance/', {
          state: { jobsiteID: jobSite.id, jobsiteName: jobSite.jobsiteName }
      });
    } ;

    //deletes the jobsite from the database, ask the user if they are sure they want to delete the jobsite.
    const handleDeleteJobsite =  () => { 
      setShowDeleteModal(true);
    }

    // Confirm delete action
    const handleConfirmDelete = () => {
      if (deleteConfirmInput === jobSite.jobsiteName) {
        dispatch(deleteJobsite(jobSite.id)); // Ensure jobSite.id is passed
        setShowDeleteModal(false);
        setDeleteConfirmInput("");
      }
    }

    const handleSelectForeman = () => {
      setShowForemanModal(true);
    }

    // Handler for Pause button
    const handleToggleStatus = () => {
      dispatch(toggleJobsiteStatus(jobSite.id));
      setShowDropdown(false); // Close the dropdown after toggling status
    }

    return (
    <>
      <div className={`mb-10 rounded-2xl border w-full sm:w-80 max-w-md mx-auto bg-gradient-to-b from-charcoal via-tan to-ivory ${jobSite.isActive ? "opacity-100" : "opacity-40"} transition-opacity duration-300`}>
        
        {/* button to toggle the jonsite status to true or false */}
        <div className="flex justify-between">
          {/* display the status as an h1 */}
          <div className="mt-1">
            <h1
              className={`ml-1 mb-1 mt-1 text-robin rounded text-xl font-medium font-kanit px-1 py-1`}
            >
              {jobSite.jobsiteName.toUpperCase()}
            </h1>

          </div>
        

          <div className="mt-1 relative">
            
            <div>
              <button
                  className="mt-2 mr-2 transform hover:scale-150"
                  onClick={handleCogClick}
                > 

                  <FaCog className="text-orangem text-2xl"/>
                </button>

            </div>
            
            {/* COG Dropdown  */}

              {showDropdown && (
                <div className="absolute right-0 mt-2 z-10"> 
                  <div className="w-48 rounded shadow-lg ring-1 ring-black ring-opacity-5">

                      <div className="py-1 bg-white rounded-lg" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">

                          <div className="rounded  hover:bg-sage"> 
                            <button
                              className="block px-4 text-md text-black"
                              role="menuitem"
                              onClick= {handleSelectForeman}
                            >
                              View Foremen
                            </button>
                          </div>

                          {/* Pause button */}
                          <div className="rounded hover:bg-sage">
                            <button
                              className="block px-4 text-md text-black"
                              role="menuitem"
                              onClick={handleToggleStatus}
                            >
                              {jobSite.isActive ? "Pause Jobsite" : "Activate Jobsite"}
                            </button>
                          </div>

                          <div className=" rounded hover:bg-red-100"> 
                            <button
                              className="block px-4 text-red-600 font-semibold"
                              role="menuitem"
                              onClick={handleDeleteJobsite}
                            > Delete Jobsite
                            </button>
                          </div>
                        
                      </div>

                  </div>
                  
                </div>
              )}

          </div>
        
        </div>
          {/* image of jobsite */}
            <div className="relative p-2" >
              <img src={jobSite.s3URL ? jobSite.s3URL : "/constructionSite.png"} alt="Job Site" className="w-full h-64 object-cover rounded-md cursor-pointer" />

            </div>

        
            {/*  Address and foreman*/}
            <div className="mb-2">
              <h1 
                className="text-sm hover:underline cursor-pointer mb-1 text-right mr-2 font-sans font-semibold text-teal" 
                onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(jobSite.address.split(', USA')[0])}`, "_blank")}>
                {jobSite.address.split(', USA')[0]}
              </h1>
              
            </div>

            {/* notes section */}
          <div className="relative mb-2">
            
            {editNotesClicked ? (
              <NotesInCards jobSite={jobSite} setEditNotesClicked={setEditNotesClicked} />
              ) : (
              <div className="text-sm rounded-lg p-0.5 border-b-4 overflow-y-auto max-h-32 h-32 cursor-default bg-sage" >
                {jobSite.siteNotes ? (
                  Object.entries(jobSite.siteNotes).map(([key, value]) => (
                  <p key={key} className="text-gray-800 font-thin text-left ml-1">
                      <span className="mr-1 font-normal"> {`${key}:`} </span>{`${value}`}</p>
                  ))
              ) : (
                <div className="flex items-center justify-center h-full">
                  <p className="text-gray-600 font-thin ">No Notes - you can add one!</p>
                </div>
                )}
            </div>
            )}
        </div>

          {/* Row of icons */}
        
          {!editNotesClicked && (
         

            <div className='flex justify-between  mb-4 px-10'>
              

              {/* Show jobsite attendace button */}
              <button className='relative group' onClick={handleViewAttendance}>
                  <FaUserClock className="text-2xl text-lilac cursor-pointer" />
                  <span className="absolute top-[-50px] p-0.5  flex items-center justify-center 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gray-600
                      text-white text-xs rounded-md font-thin">
                      View Attendance
                  </span>
            </button>

              {/* Notes Button */}
              <button className="relative group" onClick={handleEditNotes}>
                <FaStickyNote className="text-2xl text-lilac cursor-pointer" />
                  <span className="absolute top-[-40px] p-0.5 left-6  flex items-center justify-center 
                      opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gray-600
                      text-white text-xs rounded-md  font-thin">
                      Post a note.
                    </span>
              </button>
            </div>
          )}


          {/* Modals */}
          {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full">
            <h2 className="text-lg font-bold mb-2 text-red-700">Delete Jobsite</h2>
            <p className="mb-4 text-gray-700">
              Deleting this jobsite is <span className="font-semibold">permanent</span> and should only be done if your project is complete.<br />
              To confirm, type <span className="font-mono bg-gray-100 px-1">{jobSite.jobsiteName}</span> below:
            </p>
            <input
              className="border rounded px-2 py-1 w-full mb-4"
              value={deleteConfirmInput}
              onChange={e => setDeleteConfirmInput(e.target.value)}
              placeholder="Type jobsite name to confirm"
            />
            <div className="flex justify-end gap-2">
              <button
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300"
                onClick={() => { setShowDeleteModal(false); setDeleteConfirmInput(""); }}
              >
                Cancel
              </button>
              <button
                className={`px-3 py-1 rounded text-white ${deleteConfirmInput === jobSite.jobsiteName ? "bg-red-600 hover:bg-red-700" : "bg-red-300 cursor-not-allowed"}`}
                disabled={deleteConfirmInput !== jobSite.jobsiteName}
                onClick={handleConfirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <SelectForemanModal isOpen={showForemanModal} onClose={() => setShowForemanModal(false)} jobsiteId={jobSite.id} />
          </div>
    </>

    );
  }
  
  export default JobSiteCard;
